<skl-dialog-content-ins>
	<skl-dialog-header-ins
		id="clients-import-dialog-header"
		[title]="'scenes.dialogs.clients-import.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container
			[skl-focus-by]>
			<ins-form-field
				[label]="'scenes.dialogs.clients-import.controls.source-file.name' | translate">
				<skl-filepicker-ins
					[accept]="'.epp, .zip'"
					[maxSize]="5"
					id="clients-import-dialog-filepicker"
					(onPick)="viewModel.onFilePick($event)"
					(onClear)="viewModel.onFileClear()"
					[placeholder]="'scenes.dialogs.clients-import.controls.source-file.placeholder' | translate">
				</skl-filepicker-ins>
				<div class="text--right" slot="subscript" id="clients-import-dialog-filepicker-subscript">
					{{ 'ui.file-picker.max-size-message' | translate: {maxFileSize: '5 MB'} }}
				</div>
			</ins-form-field>
			@if (viewModel.passwordVisible()) {
				<ins-form-field
					[label]="'scenes.dialogs.clients-import.controls.password.name' | translate">
					<skl-password-ins
						[(ngModel)]="viewModel.password"
						id="clients-import-dialog-password"
						(ngModelChange)="onPasswordChange()"
						[placeholder]="'scenes.dialogs.clients-import.controls.password.name' | translate">
					</skl-password-ins>
					<div slot="end" [ngClass]="{ 'display--none': !viewModel.passwordWarningVisible() }">
						<div>
							<skl-icon
								class="align--tiny-left"
								id="clients-import-dialog-password-warning"
								[tooltip]="'scenes.dialogs.clients-import.controls.password.warning' | translate"
								color="error"
								name="exclamation-circle">
							</skl-icon>
						</div>
					</div>
				</ins-form-field>
			}
			<ins-form-field
				[label]="'scenes.dialogs.clients-import.controls.identification-kind.name' | translate">
				<ins-select
					display-text="label"
					id="clients-import-dialog-kind"
					[converter]="viewModel.identificationKindValueConverter"
					[(ngModel)]="viewModel.identificationKind"
					[placeholder]="'scenes.dialogs.clients-import.controls.identification-kind.placeholder' | translate">
					@for (item of viewModel.identificationKinds; track item) {
						<ins-option
							[value]="item">
							{{item.label}}
						</ins-option>
					}
				</ins-select>
			</ins-form-field>
			<ins-form-field
				[label]="'scenes.dialogs.clients-import.controls.handle-duplicates.name' | translate">
				<ins-select
					display-text="label"
					[converter]="viewModel.handleDuplicatesValueConverter"
					id="clients-import-dialog-handle-duplicate"
					[(ngModel)]="viewModel.handleDuplicate"
					[placeholder]="'scenes.dialogs.clients-import.controls.handle-duplicates.placeholder' | translate">
					@for (item of viewModel.handleDuplicates; track item) {
						<ins-option
							[value]="item">
							{{item.label}}
						</ins-option>
					}
				</ins-select>
			</ins-form-field>
			<div
				class="align--medium-bottom"
				id="product-export-dialog-manual-inline-warning-text">
				<div class="notification-container">
					<skl-icon name="exclamation-triangle" class="text--warning"></skl-icon>
					<div class="notification-container--text">
						{{ 'scenes.dialogs.clients-import.messages.warning' | translate }}
					</div>
				</div>
			</div>
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="clients-import-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.dialogs.clients-import.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			[disabled]="!viewModel.uploadedFile"
			id="clients-import-dialog-confirm-button"
			[spinner]="isImporting"
			(click)="onImportAsync()">
			{{ 'scenes.dialogs.clients-import.buttons.confirm' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>